import React from 'react';
import { motion } from 'framer-motion';
import { TreeDeciduous, Wind, Droplets } from 'lucide-react';
import './HeroMetrics.css';

interface HeroMetricsProps {
  totalTrees: number;
  speciesCount: number;
  totalCarbonTonnes: number;
  oxygenLiters: number;
}

export const HeroMetrics: React.FC<HeroMetricsProps> = ({
  totalTrees,
  speciesCount,
  totalCarbonTonnes,
  oxygenLiters,
}) => {
  const metrics = [
    {
      icon: <TreeDeciduous size={48} />,
      value: totalTrees,
      label: 'Trees',
      sublabel: `${speciesCount} species`,
      color: 'forest',
      delay: 0,
    },
    {
      icon: <Wind size={48} />,
      value: `${(oxygenLiters / 10000000).toFixed(2)}`,
      label: 'Crore Liters O₂/year',
      sublabel: 'Oxygen production',
      color: 'blue',
      delay: 0.1,
    },
    {
      icon: <Droplets size={48} />,
      value: Math.round(totalCarbonTonnes),
      label: 'Tonnes CO₂',
      sublabel: 'Carbon sequestered',
      color: 'earth',
      delay: 0.2,
    },
  ];

  return (
    <section className="hero-metrics">
      <motion.div
        className="hero-metrics__container"
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.4, 0, 0.2, 1] }}
      >
        <div className="hero-metrics__header">
          <h2 className="hero-metrics__title">Environmental Impact at a Glance</h2>
          <p className="hero-metrics__subtitle">
            Empress Botanical Garden Front Gallery's contribution to Pune's ecosystem
          </p>
        </div>

        <div className="hero-metrics__grid">
          {metrics.map((metric, index) => (
            <motion.div
              key={index}
              className={`hero-metrics__card hero-metrics__card--${metric.color}`}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{
                duration: 0.5,
                delay: metric.delay,
                ease: [0.4, 0, 0.2, 1],
              }}
              whileHover={{ scale: 1.05, y: -8 }}
            >
              <div className="hero-metrics__icon-wrapper">{metric.icon}</div>
              <div className="hero-metrics__content">
                <div className="hero-metrics__value">
                  {typeof metric.value === 'number'
                    ? metric.value.toLocaleString('en-IN')
                    : metric.value}
                </div>
                <div className="hero-metrics__label">{metric.label}</div>
                <div className="hero-metrics__sublabel">{metric.sublabel}</div>
              </div>
              <div className="hero-metrics__decoration" />
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default HeroMetrics;
